import { DateService, IntlManager } from '@atlas/core';

import { FREESPIN_STATUS } from 'common/constants';
import { resolveFreespinExpirationMs } from 'common/utils/resolveFreespinExpirationMs';

import {
  FINISHED_BONUS_DETAILS_DATE_FORMAT,
  freespinStatusDateLabelKey,
} from './finishedBonusDetailsShared';

const formatFreespinFinishedDetailsDate = ms => {
  if (ms == null) {
    return null;
  }

  return DateService.getFormattedDate(ms, FINISHED_BONUS_DETAILS_DATE_FORMAT);
};

export const buildFinishedClientFreespinDetailsRows = ({ extra = {}, freeSpin }) => {
  const status = freeSpin?.status;
  const rows = [];

  if (status === FREESPIN_STATUS.EXPIRED) {
    rows.push({
      labelKey: freespinStatusDateLabelKey(status),
      valueText: formatFreespinFinishedDetailsDate(resolveFreespinExpirationMs(freeSpin)),
    });
  }

  const freeSpinAmount = extra.freeSpinAmount ?? freeSpin?.freeSpinAmount;
  const fsAmountText =
    freeSpinAmount != null && freeSpinAmount !== ''
      ? IntlManager.formatMoney(freeSpinAmount)
      : null;

  rows.push({
    labelKey: 'bonus_info_freespin_amount',
    valueText: fsAmountText,
  });

  rows.push({
    labelKey: 'bonus_info_freespin_count',
    valueText:
      freeSpin?.freeSpin?.numberOfSpins != null ? String(freeSpin.freeSpin.numberOfSpins) : null,
  });

  return rows;
};
